import { ROUTES } from '@/constants/routes'

export const FOOTER_EMAIL = 'mma.autozakaz@gmail.com'

export const FOOTER_REQUISITES = ['ИП Прокин Михаил Юрьевич', 'ИНН 503115406038', 'ОГРНИП 323508100383880']

export const FOOTER_MENU = [
  { label: 'Калькулятор', to: ROUTES.CALCULATOR },
  { label: 'Каталог', to: ROUTES.CATALOG },
  { label: 'Фин. услуги', to: ROUTES.FIN_SERVICES },
  { label: 'О компании', to: ROUTES.ABOUT },
  { label: 'Блог', to: ROUTES.BLOG },
] as const

export const FOOTER_ADDRESS = ['Москва, ул. Кирпичные Выемки,', 'д. 2, к. 1, оф. 14']

export const FOOTER_SCHEDULE = ['9:00 - 21:00', 'без выходных']

export const FOOTER_SOCIALS = [
  { label: 'Telegram', href: 'https://t.me/', icon: '/icons/telegram.svg' },
  { label: 'ВКонтакте', href: 'https://vk.com/', icon: '/icons/vk.svg' },
] as const

export const FOOTER_LEGAL = [
  { label: 'Отказ от ответственности', to: '/disclaimer' },
  { label: 'Политика конфиденциальности', to: '/privacy' },
  { label: 'Политика обработки cookie', to: '/cookies' },
] as const
